import { ChangeDetectionStrategy, Component, HostBinding, computed, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import clsx from 'clsx';

/**
 * PDP subtotal display for the "Add to cart" button row. Replaces the legacy
 * `<pxw-product-price layout="product-subtotal">` per the product-price split
 * plan. Pure price display: list strikethrough + current. **No promo savings
 * are surfaced here** — per briefing §4, realized savings live in the cart;
 * the PDP shows only mechanics (tags) and the note "se aplica en el carrito".
 */
@Component({
  selector: 'pxw-product-detail-subtotal',
  templateUrl: './product-detail-subtotal.component.html',
  styleUrls: ['./product-detail-subtotal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, CurrencyFormatPipe],
})
export class ProductDetailSubtotalComponent {
  price = input.required<number>();
  priceDiscount = input<number>();

  hasPriceDiscount = computed(() => {
    const discount = this.priceDiscount();
    return discount != null && discount < this.price();
  });

  @HostBinding('class')
  get classNames() {
    return clsx({
      'with-discount': this.hasPriceDiscount(),
    });
  }
}
